import { Box, BoxProps, Spinner, SpinnerProps } from '@chakra-ui/react';
import React from 'react';

interface LoaderViewProps extends BoxProps {
  loaderProps?: SpinnerProps;
}
/**
 * loaderProps: Provide spinner component props if needed.
 * box props: Provide props to the container of spinner to override the style of container.
 * */
const LoaderView = ({ loaderProps, ...containerProps }: LoaderViewProps) => {
  const spinnerProps = loaderProps ?? {};

  return (
    <Box
      width="100%"
      minHeight="150px"
      display="flex"
      justifyContent="center"
      alignItems="center"
      color="neutral.700"
      {...containerProps}
    >
      <Spinner size="lg" color="inherit" thickness="3px" {...spinnerProps} />
    </Box>
  );
};

export default LoaderView;
